import { __awaiter } from '../../_virtual/_tslib.js';
import { connect } from 'starknetkit';
import { isInArgentMobileAppBrowser, ArgentMobileConnector } from 'starknetkit/argentMobile';
import { RpcProvider, constants } from 'starknet';
import { logger } from '@dynamic-labs/wallet-connector-core';
import ArgentXBase from './argentxBase.js';

class ArgentXMobile extends ArgentXBase {
    constructor(opts) {
        super('Argent X - Mobile', 'argentXMobile', opts);
        this.projectId = opts.projectId;
        this.appName = opts.appName;
        this.appLogoUrls = opts.appLogoUrl
            ? [opts.appLogoUrl]
            : undefined;
    }
    filter() {
        if (super.filter()) {
            return !isInArgentMobileAppBrowser();
        }
        return false;
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const nodeUrl = this.getSelectedNodeUrl();
                const wallet = yield this.getWallet();
                let connection;
                if (this.hasValidSession()) {
                    if (wallet && wallet.isConnected) {
                        return Promise.resolve();
                    }
                    else {
                        connection = yield connect({
                            modalMode: 'neverAsk',
                            provider: new RpcProvider({ nodeUrl }),
                        });
                    }
                    // No valid session
                }
                else {
                    connection = yield connect({
                        connectors: [
                            new ArgentMobileConnector({
                                chainId: this.getSelectedNetworkName() || constants.NetworkName.SN_MAIN,
                                dappName: this.appName,
                                icons: this.appLogoUrls,
                                projectId: this.projectId,
                                provider: new RpcProvider({
                                    nodeUrl,
                                }),
                                url: window.location.hostname,
                            }),
                        ],
                    });
                }
                if (connection && connection.wallet && connection.wallet.isConnected) {
                    this.wallet = connection.wallet;
                }
                else {
                    throw new Error('Failed to connect to Starknet');
                }
            }
            catch (err) {
                logger.error('Error establishing connection to Argent Mobile', err);
                return;
            }
        });
    }
    getConnectedAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.hasValidSession()) {
                return [];
            }
            const address = yield this.fetchPublicAddress();
            if (!address)
                return [];
            return [address];
        });
    }
    hasValidSession() {
        var _a, _b;
        const sessionItem = localStorage.getItem('wc@2:client:0.3//session');
        if (sessionItem) {
            const sessionItemJson = JSON.parse(sessionItem);
            if ((_b = (_a = sessionItemJson[0].peer) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.name.includes('Argent')) {
                return true;
            }
        }
        return false;
    }
}

export { ArgentXMobile };
